import { Gtm } from '@/domains/core/tracking/utils/Gtm';
import { generateRatingItems } from '@/domains/productDiscovery/Listings/components/Filters/components/RatingsFilter/utils/generateRatingItems';
import { useFacet } from '@/domains/productDiscovery/Listings/facets/hooks/useFacet';
import { useCategoryFamilyId } from '@/domains/productDiscovery/Listings/pages/Category/hooks/useCategoryFamilyId';
import { useCategoryId } from '@/domains/productDiscovery/Listings/pages/Category/hooks/useCategoryId';
import { useCategoryLevel } from '@/domains/productDiscovery/Listings/pages/Category/hooks/useCategoryLevel';

import { QuickFilterButton } from '../QuickFilterButton/QuickFilterButton';
import { fourAndMoreRatings } from './translations';

export const QuickRatingsFilter = () => {
  const categoryId = useCategoryId();
  const categoryLevel = useCategoryLevel();
  const categoryFamilyId = useCategoryFamilyId();

  const { facet, refineFacetValue } = useFacet('rating_rounded_down');

  const ratingValue = generateRatingItems(facet?.values).filter(
    (el) => el.id === '4&more',
  );
  if (!ratingValue || !ratingValue[0]) return null;

  const handleClick = async () => {
    const { generateFiltersTracking } = await import(
      '@/domains/productDiscovery/Listings/components/Filters/tracking/generateFiltersTracking'
    );
    Gtm.push(
      generateFiltersTracking({
        e_label: fourAndMoreRatings.label,
        filter_id: '4&more',
        filter_name: fourAndMoreRatings.label,
        filter_value: ratingValue[0].value,
        filter_position: 1,
        filter_count: 1,
        is_quick_filter: true,
        category_id: categoryId,
        category_level: categoryLevel,
        family_id: categoryFamilyId,
      }),
    );

    refineFacetValue(
      ratingValue[0].isRefined ? undefined : ratingValue[0].value,
      true,
    );
  };

  return (
    <QuickFilterButton
      onClick={handleClick}
      text={fourAndMoreRatings.label}
      active={ratingValue[0].isRefined}
    />
  );
};
